export const fetchLimit = 75

export const apiURL = 'https://api.scryfall.com'
export const cdnURL = 'https://cards.scryfall.io'
